import React from "react";

/**
 * Sets drag data for a waterfall item when a drag event starts.
 *
 * @param event - The drag event from the HTML div element.
 * @param item - The identifier or name of the item being dragged.
 * @param rowId - Optional row identifier, if relevant to the drag context.
 */
export function handleDragStartItem(
  event: React.DragEvent<HTMLDivElement>,
  item: string,
  rowId?: string
) {
  event.dataTransfer.setData("item", item);
  if (rowId) event.dataTransfer.setData("fromRowId", rowId);
}

/**
 * Empty callback for dropped-back items. Use as a default when no action is needed.
 * @param item - The item dropped back (string)
 */
export function handleItemDroppedBack(item: string) {
  // No operation performed
}